<template>
  <chart-canvas :option="option" :empty="empty" />
</template>

<script>
import ChartCanvas from "./ChartCanvas.vue";
import { colors, lineTrendOption } from "./chart-options";

export default {
  name: "TrafficTrendChart",
  components: { ChartCanvas },
  props: { trend: { type: Array, default: () => [] } },
  computed: {
    empty() {
      return !this.trend.some(
        (item) =>
          item.clicks !== null ||
          item.impressions !== null ||
          item.avg_position !== null
      );
    },
    option() {
      return lineTrendOption(
        this.trend,
        [
          { name: "点击", key: "clicks", color: colors.blue },
          {
            name: "曝光",
            key: "impressions",
            color: colors.orange,
            yAxisIndex: 1,
          },
          { name: "平均排名", key: "avg_position", color: colors.green },
        ],
        true
      );
    },
  },
};
</script>
